import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { DeleteAllowedDomainRPC } from "./deleteAllowedDomainRPC";

export class DeleteAllowedDomainRPCClientImpl extends DeleteAllowedDomainRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: DeleteAllowedDomainRPC.Request): Promise<LeoRPCResult<DeleteAllowedDomainRPC.Response, DeleteAllowedDomainRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "email-cycle/DeleteAllowedDomain",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      DeleteAllowedDomainRPC.ResponseDTO,
      DeleteAllowedDomainRPC.Errors.ErrorsDTO,
      DeleteAllowedDomainRPC.Response,
      DeleteAllowedDomainRPC.Errors.Errors
    >(
      response,
      "email-cycle/DeleteAllowedDomain",
      DeleteAllowedDomainRPC.Response.fromDTO,
      DeleteAllowedDomainRPC.Errors.fromDTO
    );
  }
}
